<template>
<div></div>
</template>

<script>
import router from "@/router.js";
export default {
  created() {
      localStorage.clear();
      router.push("/login");
  }
};
</script>
